import classNames from 'classnames';
import { IoMdClose } from 'react-icons/io';

import Button from '../../../components/Button';
import { PintoAnnouncementNotificationType, PintoVoucherStatus } from '../../../core/graphql/types';
import { getDayTime } from '../../../utils/dayjs';

export interface IPropsNotificationListItem {
  _id: string;
  title: string;
  url?: string | null;
  description: string;
  notifiedAt?: string | null;
  createdAt: string;
  platforms: string[];
  type: PintoAnnouncementNotificationType;
  notified: boolean;
  onDelete?: () => void;
}

export const COUPON_STATUS = {
  [PintoVoucherStatus.Scheduled]: 'Scheduled',
  [PintoVoucherStatus.Active]: 'Completed',
  [PintoVoucherStatus.Expired]: 'Completed',
};

export const COUPON_STATUS_CLASS_NAME = {
  [PintoVoucherStatus.Scheduled]: 'badge',
  [PintoVoucherStatus.Active]: 'badge badge-success',
  [PintoVoucherStatus.Expired]: 'badge badge-success',
};

// export const TYPE_STATUS = {
//   [PintoAnnouncementNotificationType.Scheduled]: 'Scheduled',
//   [PintoAnnouncementNotificationType.Active]: 'Completed',
//   [PintoAnnouncementNotificationType.Expired]: 'Completed',
// };

export const TYPE_STATUS_CLASS_NAME = {
  [PintoAnnouncementNotificationType.All]: 'badge badge-error',
  [PintoAnnouncementNotificationType.SpecificUser]: 'badge badge-info',
};

const DATE_FORMAT = 'DD-MM-YYYY hh:mm A';

const IPropsNotificationListItem = ({ title, url, description, notified, notifiedAt, platforms, type, onDelete }: IPropsNotificationListItem) => {
  return (
    <tr className="hover font-tt">
      <td className="max-w-[250px] break-words whitespace-normal">
        <div className="whitespace-normal line-clamp-4">{title}</div>
      </td>
      <td className="max-w-[250px] break-words whitespace-normal">
        <div className="whitespace-normal line-clamp-4">{description}</div>
      </td>
      <td className="max-w-[250px] break-words whitespace-normal">
        <div className="whitespace-normal line-clamp-4">{url || '-'}</div>
      </td>
      <td>{notifiedAt ? getDayTime(notifiedAt || '', DATE_FORMAT) : '-'}</td>
      <td>
        <div
          className={classNames('badge text-white uppercase text-xs px-3 py-1 font-bold', {
            'bg-green-600': notified,
            'bg-gray-400': !notified,
          })}
          style={{ minWidth: '100px', textAlign: 'center' }}
        >
          {notified ? 'NOTIFIED' : 'NOT SENT'}
        </div>
      </td>
      <td>
        <div
          className={classNames('badge text-white uppercase text-xs px-3 py-1', {
            'badge-error bg-red-500': type === PintoAnnouncementNotificationType.All,
            'badge-info bg-blue-400': type === PintoAnnouncementNotificationType.SpecificUser,
          })}
          style={{ minWidth: '100px', textAlign: 'center' }}
        >
          {type}
        </div>
      </td>
      <td>
        {(['web', 'apple', 'google'] as const).map((platformKey) => {
          const isActive = platforms.includes(platformKey);
          const labelMap: Record<typeof platformKey, string> = {
            web: 'WEB',
            apple: 'IOS',
            google: 'ANDROID',
          };

          return (
            <div
              key={platformKey}
              className={classNames('badge', {
                'badge-warning': isActive,
                'badge-outline': !isActive,
              })}
            >
              {labelMap[platformKey]}
            </div>
          );
        })}
      </td>
      <td>
        <Button disabled={notified} type="ghost" color="red" className="space-x-4 text-colorsBrandRed01Primary" onClick={onDelete}>
          <IoMdClose />
          <span>Cancel</span>
        </Button>
      </td>
    </tr>
  );
};

export default IPropsNotificationListItem;
